import fetcher from '@/forApp/utils/fetcher/fetcher';
import type { ItemSelectT } from '@/shared/Selects/Select';
import type {
  AllowFiltersT,
  DefaultFilterT,
  EntityTypeT,
  MenuT,
  MoreFiltersT,
} from '@/widgets/MainBlock/MainSearch/types';

export const getMainFiltres = async (type: string): Promise<DefaultFilterT> => {
  const allowFilters = await fetcher<AllowFiltersT>(
    'GET',
    `/entity-types/allow-filters/${type}`,
  );
  const moreFilter = await fetcher<MoreFiltersT>(
    'GET',
    `/entity-types/more-filters/${type}`,
  );

  const isBrowser = typeof window !== 'undefined';
  let menu: MenuT[] = [];

  if (isBrowser) {
    const menuLs = localStorage.getItem('menuSe');
    menu = menuLs ? JSON.parse(menuLs) : [];
    if (!menu.length) {
      const menuResp = await fetcher<MenuT[]>('GET', '/menu');
      menu = menuResp.data;
      try {
        localStorage.setItem('menuSe', JSON.stringify(menu));
      } catch {}
    }
  } else {
    const menuResp = await fetcher<MenuT[]>('GET', '/menu');
    menu = menuResp.data;
  }

  const sortedType: Record<string, EntityTypeT[]> = {};
  if (menu.length) {
    menu.forEach((item) => {
      sortedType[item.slug] = item.items;
    });
  }

  const transformedTypeEntity: Record<string, ItemSelectT[]> = {};
  Object.keys(sortedType).forEach((key) => {
    transformedTypeEntity[key] = sortedType[key].map((item) => ({
      value: item!.slug,
      title: item!.name,
    }));
  });

  return {
    allowFilters: {
      cities: allowFilters.data.cities.map(
        (item): ItemSelectT => ({
          value: item.slug ? item.slug : '',
          title: item.name,
        }),
      ),
      filters: allowFilters.data.filters,
    },
    moreFilter: moreFilter.data,
    typeEntity: transformedTypeEntity,
  };
};
